module.exports = __webpack_public_path__ + "img/tarjeta_servicios_tallerCRM.fc37c744.jpg";